import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useState, useEffect } from 'react';
import { useTableColumns } from './hooks/useTableColumns';

import "assets/scss/billingPortal/modules/performedJournal.scss";
import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayEmpty, isArrayNotEmpty, isNullUndefined } from 'functions';
import useOutletsActions from 'dataflow/billingPortal/actions/useOutlet.actions';
import useFilters from './hooks/useFilters';
import { Dropdown } from 'components/filters/Dropdown';
import { DateRangePicker } from 'components/form/DateRangePicker';
import FiltersWrapper from 'components/filters/FiltersWrapper';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import moment from 'moment';
import { MultiFilters } from 'components/filters/MultiFilters';
import { ListBoxModal } from 'components/modals/ListBoxModal';
import { Toaster } from 'components/notification/Toaster';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';
import ic_export from 'assets/images/ic_export.svg';
import useExportData from './hooks/useExportData';

export default function PerformedJournal() {

    const [isExporting, setIsExporting] = useState();

    const {
        performedDate_from, setPerformedDate_from,
        performedDate_to, setPerformedDate_to,
        comId, setComId,
        outletIDs, setOutletIDs,
        customerEmail, systemRemark,

        isResetRequired,
        isFiltering, onFilterSubmit,
        isOutletListModalVisible, setIsOutletListModalVisible
    } = useFilters();
    const {
        getAllComList_requesting, allComList
    } = useCustomSelector("accountControl");
    let {
        getAllOutletList_requesting, allOutletList,
        getOutletLogs_requesting, outletLogs, outletLogsHeaders,
        getAllOutletLogs_requesting, allOutletLogs
    } = useCustomSelector("outlet");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getOutletLogs, getAllOutletLogs
    } = useOutletsActions();

    const columns = useTableColumns();

    // handle export
    const exportData = useExportData();
    useEffect(() => {
        if (isExporting && !getAllOutletLogs_requesting && isArrayNotEmpty(allOutletLogs)) 
            exportData();
    }, [getAllOutletLogs_requesting]);

    return (
        <DashboardLayout
            headerTitle={"Performed Journal"}

            bodyClassName={"performed-journal"}
            body={(
                <GeneralTable
                    className={"performed-journal__table"}
                    columns={columns}
                    data={userPermissions?.Internal_PerformedLog_View? outletLogs: []}

                    getTableData={getOutletLogs}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>

                                    {/* More Actions */}
                                    <SubmenuTooltip
                                        buttonClassName={"top-section__more-actions"}
                                        menuItems={[
                                            {
                                                icon: ic_export,
                                                label: "Export",
                                                isDisabled: isArrayEmpty(outletLogs) || isNullUndefined(outletLogs),
                                                onClick: () => {
                                                    setIsExporting(true);
                                                    getAllOutletLogs(getTotalCountFromHeader(outletLogsHeaders), filterOptions);
                                                },
                                            }
                                        ]}
                                    >
                                        <MoreButton
                                            className={"more-actions__icon-wrapper"}
                                            iconClassName={"icon-wrapper__icon"}
                                        />
                                    </SubmenuTooltip>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section d-flex"}>
                                    {/* <MultiFilters
                                        defaultFilterOption={{
                                            label: "Username", 
                                            propertyName: "loggerUser",
                                            placeholder: "Username",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Com ID", 
                                                propertyName: "comId",
                                                placeholder: "COM ID",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Date", 
                                                propertyName_start: "startDate",
                                                propertyName_end: "endDate",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange",
                                                isNotUsingMonthYear: true
                                            },
                                            {
                                                label: "Outlets", 
                                                propertyName: "outletID",
                                                placeholder: "Select Outlet(s)",
                                                options:[
                                                    {
                                                        label: "COM ID",
                                                        value: "comId"
                                                    },
                                                    {
                                                        label: "Date Range",
                                                        value: "dateRange"
                                                    },
                                                    {
                                                        label: "Outlets",
                                                        value: "outlets"
                                                    },
                                                    {
                                                        label: "Customer Email",
                                                        value: "customerEmail"
                                                    }
                                                ],
                                                inputType: "dropdown"
                                            },
                                            {
                                                label: "Customer Email", 
                                                propertyName: "customerEmail",
                                                placeholder: "e.g. example@gmail.com",
                                                inputType: "search"
                                            },
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                        }}
                                    /> */}



                                    <FiltersWrapper
                                        isFiltering={isFiltering}
                                        isDisabled={!(userPermissions?.Internal_PerformedLog_View)}
                                        submitDisabledMsg={"'Com Info: View' permission required"} 
                                        clearDisabledMsg={"'Com Info: View' permission required"}
                                        onSubmit={() => onFilterSubmit(setFilterOptions, filterOptions)}
                                        onClear={() => onFilterSubmit(setFilterOptions, {}, true)}
                                    >
                                        <Dropdown
                                            className={"bottom-section__company-id"}
                                            label={"COM ID"}

                                            selectedValueClassName={"company-id__input"}
                                            isListLoading={getAllComList_requesting}

                                            options={(isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                let comId = obj?.ComId? obj.ComId:"";
                                                let comName = obj?.ComName? obj?.ComName:"";

                                                return {
                                                    label: comId + " - " + comName,
                                                    value: comId
                                                };
                                            }):""}

                                            valueFromParent={comId}
                                            selectedValue_default={comId}
                                            onChange={(value) => {
                                                setOutletIDs([]);
                                                setComId(value);
                                            }}

                                            isResetRequired={isResetRequired}

                                            isInputDigitOnly isSearchable
                                        />

                                        <Dropdown
                                            className={"bottom-section__outlet"}
                                            label={"Outlet"}

                                            isUpdatingLabel_fromParent
                                            selectedValueLabel_default={(isArrayNotEmpty(outletIDs))? outletIDs.length + " Outlets":""}
                                            placeholder={"Select Outlet(s)"}

                                            selectedValueClassName={"outlet__input"}
                                            onClick={() => {
                                                if (comId)
                                                    setIsOutletListModalVisible(true);
                                                else {
                                                    Toaster({
                                                        type: "info",
                                                        msg: "COM ID filter required"
                                                    })
                                                }
                                            }}

                                            isResetRequired={isResetRequired}
                                        />
                                        <ListBoxModal
                                            isModalVisible={isOutletListModalVisible}
                                            updateParentState={setIsOutletListModalVisible}

                                            title={"Outlet"}

                                            header={"List"}

                                            initSelectedIndexes={(isArrayNotEmpty(outletIDs))? outletIDs.map((id) => {
                                                // Find position of the ids in the "allOutletList" list
                                                for (let i = 0; i < allOutletList.length; i++) {
                                                    if (allOutletList[i]?.ID === id) {
                                                        return i;
                                                    }
                                                }
                                            }):[]}
                                            labelList={(isArrayNotEmpty(allOutletList))? allOutletList.map((obj) => {
                                                return obj?.LOCATIONNAME;
                                            }):[]}
                                            list={(isArrayNotEmpty(allOutletList))? allOutletList.map((obj) => {
                                                return obj?.ID;
                                            }):[]}
                                            isListLoading={getAllOutletList_requesting}

                                            actionTxt={"Save"}
                                            handleOnConfirm={(list) => { 
                                                setOutletIDs(list);
                                                setIsOutletListModalVisible(false);
                                            }}

                                            listBoxOptions={{
                                                maxSelection: 5
                                            }}
                                        />

                                        <DateRangePicker
                                            className={"bottom-section__performed-date-range"}

                                            isLabelRequired
                                            label={"Date"}

                                            handleOnChange_start={setPerformedDate_from}
                                            handleOnEmptyInput_start={() => { 
                                                setPerformedDate_from("");
                                            }}
                                            placeholder_start={"dd/mm/yyyy"}

                                            handleOnChange_end={setPerformedDate_to}
                                            handleOnEmptyInput_end={() => { 
                                                setPerformedDate_to("");
                                            }}
                                            placeholder_end={"dd/mm/yyyy"}

                                            isResetRequired={isResetRequired}

                                            isConversionRequired_ISO8601 isSideIconVisible
                                        />

                                        <FormInput_text
                                            className={"bottom-section__customer-email"}
                                            inputLabel={"Customer Email"}

                                            placeholder={"e.g. example@gmail.com"}
                                            inputValue={customerEmail.current}
                                            propagateValueChange={(stateName, value) => {
                                                customerEmail.current = value;
                                            }}
                                            handleInputEnterKeyPress={() => onFilterSubmit(setFilterOptions, filterOptions)}
                                            isInputKeyPressHandlingRequired

                                            isInputOptional isMarginBtmOptional
                                        />

                                        <FormInput_text
                                            className={"bottom-section__system-remark"}
                                            inputLabel={"System Remark"}

                                            inputValue={systemRemark.current}
                                            propagateValueChange={(stateName, value) => {
                                                systemRemark.current = value;
                                            }}
                                            handleInputEnterKeyPress={() => onFilterSubmit(setFilterOptions, filterOptions)}
                                            isInputKeyPressHandlingRequired

                                            isResetRequired={isResetRequired}
                                            isInputOptional isMarginBtmOptional
                                        />

                                    </FiltersWrapper>
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getOutletLogs_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(outletLogsHeaders)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}